import { useRef } from 'react'
import { Outlet, useLocation } from 'react-router'
import { usePageEnter } from '@/shared/shell/usePageEnter'
import { showEmbedChrome } from '@/shared/bridge/env'
import { AiButton } from '@/features/ai/AiButton'

export default function EmbeddedShell() {
  const { pathname } = useLocation()
  const mainRef = useRef<HTMLElement>(null)
  usePageEnter(mainRef, pathname)
  return (
    <>
      <div className="app-viewport app-embedded-safe-shell flex flex-col overflow-hidden bg-bg">
        {showEmbedChrome() && (
          <div
            data-qsc-chrome="true"
            className="flex shrink-0 items-center justify-between gap-3 border-b border-border-subtle bg-surface px-4 py-3 text-preset-label text-text"
          >
            <span>QSC</span>
            <AiButton />
          </div>
        )}
        <main
          ref={mainRef}
          data-qsc-scroll="content"
          className={`min-h-0 flex-1 overflow-auto ${pathname.endsWith('/home') ? 'bg-surface' : 'bg-bg'}`}
        >
          <Outlet />
        </main>
      </div>
    </>
  )
}
